import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=745b8a3a&scoped=true"
import script from "./ImageGallery.vue?vue&type=script&lang=js"
export * from "./ImageGallery.vue?vue&type=script&lang=js"
import style0 from "./ImageGallery.vue?vue&type=style&index=0&id=745b8a3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745b8a3a",
  null
  
)

export default component.exports